import {
    GET_CART_ITEMS,
    REMOVE_CART_ITEM,
    UPDATE_CART_IN_PROGRESS,
    STORE_REMOVED_CART_ITEM,
    DELETE_STORED_CART_ITEM,
} from '../actionTypes/CartActionTypes';

export const getCartItems = (payload) => ({
    type: GET_CART_ITEMS,
    payload,
});

export const storeRemovedCartItem = (payload) => ({
    type: STORE_REMOVED_CART_ITEM,
    payload,
});

export const deleteStoredCartItem = () => ({
    type: DELETE_STORED_CART_ITEM,
});

export const removeCartItem = (payload, isSaveForLater = false) => ({
    type: REMOVE_CART_ITEM,
    payload,
    isSaveForLater,
});

export const updateCartItemInit = (updateCartItemId) => ({
    type: UPDATE_CART_IN_PROGRESS,
    updateCartItemId,
});

export default {
    getCartItems,
    removeCartItem,
    updateCartItemInit,
};
